import QuizPage from '../../components/pages/QuizPage';
import themes from '../../themes';

export default function QuizLeicht() {
  return <QuizPage difficulty="quiz-leichts" theme={themes.quiz} />;
}